import { styled } from '@linaria/react';

export const Stats = styled.ul`
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	padding: 0;
	gap: 0.8rem;
	list-style: none;
`;

export const Stat = styled.li`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	padding: 0.7rem;
	border-radius: var(--radius-xs);
	background-color: var(--color-grey-6-solid);
	gap: 0.2rem;
`;
